import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { select, Store } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils/src/model";
import { CORE_ROUTE, CoreState } from "@obg/ngx.core";
import { MessageEventService } from "@obg/ngx.global.evo";
import { RouteAction } from "@obg/ngx.router";
import { ignoreNil } from "@obg/rxjs";
import { filter, map, switchMap } from "rxjs/operators";

import { KycVerificationAction } from "./kyc-verification.action";
import { KycMessage, MessageProperties } from "./kyc-verification.model";
import { KycVerificationState } from "./kyc-verification.reducer";
import { KycVerificationSelector } from "./kyc-verification.selector";
import { KycVerificationService } from "./kyc-verification.service";

@Injectable()
export class KycMethodSelectionEffect {
	eventTriggered$ = createEffect(() =>
		this.actions$.pipe(
			ofType(KycVerificationAction.getKnowYourCustomerUrlSuccess),
			switchMap(() =>
				this.store.pipe(
					select(this.selector.getKnowYourCustomerUrl()),
					ignoreNil(),
					map((kycUrl) => new URL(kycUrl).origin),
					switchMap((origin) =>
						this.messageEventService.getMessage$<string>(undefined, origin).pipe(
							map((message) => this.service.parseMessage(message)),
							ignoreNil(),
							map((kycMessage) => KycVerificationAction.checkKycMessage(kycMessage))
						)
					)
				)
			)
		)
	);

	checkOpenPage$ = createEffect(() =>
		this.actions$.pipe(
			ofType(KycVerificationAction.checkKycMessage),
			map((x: ActionWithPayload<KycMessage>) => x.payload),
			filter((message) => message.action === MessageProperties.OpenPage),
			map(() => RouteAction.navigate(CORE_ROUTE.payment.deposit))
		)
	);

	checkIframeResize$ = createEffect(() =>
		this.actions$.pipe(
			ofType(KycVerificationAction.checkKycMessage),
			map((x: ActionWithPayload<KycMessage>) => x.payload),
			filter((message) => message.action === MessageProperties.ResizeIframe),
			map((payload) => KycVerificationAction.getIframeHeight(+payload.data!))
		)
	);

	constructor(
		private actions$: Actions,
		private service: KycVerificationService,
		private store: Store<KycVerificationState & CoreState>,
		private selector: KycVerificationSelector,
		private messageEventService: MessageEventService
	) {}
}
